(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (() => {
    const revealLinkedProduct = () => {
      const anchor = new URL(window.location.href).hash.slice(1);
      if (anchor) document.getElementById(anchor)?.scrollIntoView({ behavior: 'instant' });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', revealLinkedProduct, { once: true });
    else revealLinkedProduct();
  })();

  } catch(e) { console.error(e); }
})();
})();
